import styled from "styled-components";
import { PriceDataContainer } from "../../common/price-styles";

export const ForeignersHealthPriceContainer = styled(PriceDataContainer)``;
